(() => {
  if (window.__proHeadspaAttributionV2) return;
  window.__proHeadspaAttributionV2 = true;
  document.documentElement.dataset.proheadspaTracking = 'ready';

  const ROUTER = 'proheadspa-contact-routing.steep-king-f559.workers.dev';
  const STORAGE = 'proheadspa:attribution:v2';
  const OLD_STORAGE = 'proheadspa:attribution:v1';
  const MAX_AGE = 12 * 60 * 60 * 1000;
  const GREETINGS = {
    fr: 'Bonjour, je souhaite échanger avec Pro Headspa au sujet de mon projet.',
    en: 'Hello, I would like to discuss my project with Pro Headspa.',
    de: 'Guten Tag, ich möchte mein Projekt mit Pro Headspa besprechen.',
    es: 'Hola, me gustaría hablar con Pro Headspa sobre mi proyecto.',
    it: 'Buongiorno, vorrei parlare del mio progetto con Pro Headspa.',
    pt: 'Olá, gostaria de falar com a Pro Headspa sobre o meu projeto.',
    nl: 'Hallo, ik wil mijn project graag met Pro Headspa bespreken.',
    ja: 'こんにちは。Pro Headspaにプロジェクトについて相談したいです。',
    zh: '您好，我想向 Pro Headspa 咨询我的项目。',
  };
  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_source_platform', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'site', 'market'];
  const CAMPAIGN_KEYS = KEYS.slice(0, 10);
  const originalLinks = new WeakMap();
  let memory = null;
  let lastArrival = '';
  let privacyLoading = false;

  function permitted(purpose) {
    const privacy = window.Shopify?.customerPrivacy;
    const method = purpose === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
    try { return typeof privacy?.[method] === 'function' && privacy[method]() === true; }
    catch (_) { return false; }
  }

  function clean(value) {
    if (typeof value !== 'string' || /\{\{|\}\}|@/.test(value)) return '';
    return value.replace(/[\u0000-\u001f\u007f<>]/g, ' ').trim().slice(0, 256);
  }

  function validValues(values) {
    const result = {};
    if (!values || typeof values !== 'object') return result;
    KEYS.forEach(key => { const value = clean(values[key]); if (value) result[key] = value; });
    return result;
  }

  function clearStorage() {
    memory = null;
    lastArrival = '';
    try { window.sessionStorage.removeItem(STORAGE); window.sessionStorage.removeItem(OLD_STORAGE); }
    catch (_) { /* Browsing and contacting the team work without storage. */ }
  }

  function readAttribution() {
    if (!permitted('marketing')) return null;
    let record = memory;
    let legacy = false;
    try {
      if (!record) {
        const current = window.sessionStorage.getItem(STORAGE);
        const previous = !current && window.sessionStorage.getItem(OLD_STORAGE);
        record = JSON.parse(current || previous || 'null');
        legacy = Boolean(previous);
      }
    } catch (_) { /* Use this page's in-memory attribution if storage is blocked. */ }
    const age = record && Date.now() - record.createdAt;
    if (!record || !Number.isFinite(age) || age < 0 || age > MAX_AGE) return null;
    const values = validValues(record.values);
    if (!CAMPAIGN_KEYS.some(key => values[key])) return null;
    if (legacy) {
      memory = { createdAt: record.createdAt, values };
      try { window.sessionStorage.setItem(STORAGE, JSON.stringify(memory)); window.sessionStorage.removeItem(OLD_STORAGE); }
      catch (_) { /* Keep the previous campaign in memory if storage is blocked. */ }
    }
    return values;
  }

  function captureArrival() {
    if (!permitted('marketing') || lastArrival === window.location.href) return;
    lastArrival = window.location.href;
    const params = new URL(lastArrival).searchParams;
    const values = {};
    KEYS.forEach(key => { const value = clean(params.get(key)); if (value) values[key] = value; });
    if (!CAMPAIGN_KEYS.some(key => values[key])) return;
    memory = { createdAt: Date.now(), values };
    try { window.sessionStorage.setItem(STORAGE, JSON.stringify(memory)); }
    catch (_) { /* Same-page forwarding still works. */ }
  }

  function originalHref(link) {
    const href = link.getAttribute('href');
    let record = originalLinks.get(link);
    if (!record || (href !== record.rendered && href !== record.base)) {
      record = { base: href, rendered: href };
      originalLinks.set(link, record);
    }
    return record;
  }

  function reference(values) {
    return [values.utm_source, values.utm_campaign || values.utm_id, values.ad_id || values.utm_content].filter(Boolean).join(' · ');
  }

  function decorate(link, values) {
    if (!link?.getAttribute || !link.getAttribute('href')) return;
    const record = originalHref(link);
    let url;
    try { url = new URL(record.base, window.location.href); } catch (_) { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const isCal = ['cal.com', 'www.cal.com', 'app.cal.com'].includes(url.hostname);
    const isWhatsApp = ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname);
    const isRouter = url.hostname === ROUTER && url.pathname === '/whatsapp';
    const isContact = url.origin === window.location.origin && /\/pages\/contact(?:-us)?\/?$/.test(url.pathname);
    if (!isCal && !isWhatsApp && !isRouter && !isContact) return;

    if (values) {
      if (isWhatsApp) {
        const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        const prefix = url.searchParams.get('text') || GREETINGS[language] || GREETINGS.en;
        const ref = reference(values);
        if (ref) url.searchParams.set('text', prefix + '\n\nRef.: ' + ref);
      } else {
        // Start from the original link every time: never duplicate or mix campaign tags.
        KEYS.forEach(key => url.searchParams.delete(key));
        KEYS.forEach(key => { if (values[key]) url.searchParams.set(key, values[key]); });
      }
      record.rendered = url.href;
    } else {
      record.rendered = record.base;
    }
    if (link.getAttribute('href') !== record.rendered) link.setAttribute('href', record.rendered);
  }

  function decorateForms(values) {
    document.querySelectorAll('form[action*="/contact"], form[id*="ContactForm"]').forEach(form => {
      KEYS.forEach(key => {
        let input = form.querySelector('input[data-ph-attribution="' + key + '"]');
        if (!values?.[key]) { input?.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[' + key + ']';
          input.dataset.phAttribution = key;
          form.appendChild(input);
        }
        input.value = values[key];
      });
    });
  }

  function refresh() {
    if (!permitted('marketing')) clearStorage();
    captureArrival();
    const values = readAttribution();
    document.querySelectorAll('a[href]').forEach(link => decorate(link, values));
    decorateForms(values);
  }

  function linkFrom(event) {
    return (typeof event.composedPath === 'function' ? event.composedPath() : [])
      .find(node => node instanceof Element && node.matches('a[href]')) || event.target?.closest?.('a[href]');
  }

  function contactMethod(element) {
    const href = element.getAttribute('href') || '';
    if (href.startsWith('tel:')) return 'phone';
    if (href.startsWith('mailto:')) return 'email';
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return null; }
    if (['cal.com', 'www.cal.com', 'app.cal.com'].includes(url.hostname)) return 'appointment';
    if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com', ROUTER].includes(url.hostname)) return 'whatsapp';
    return null;
  }

  function pushContact(element, method) {
    if (!permitted('marketing') && !permitted('analytics')) return;
    const pageType = Array.from(document.body.classList).find(value => value.startsWith('template-'));
    const values = readAttribution();
    const payload = Object.assign({
      contact_method: method,
      contact_label: (element.textContent || element.getAttribute('aria-label') || '').trim().slice(0, 120),
      page_type: pageType ? pageType.replace('template-', '') : 'unknown',
      page_path: window.location.pathname,
      page_language: document.documentElement.lang || 'fr',
    }, values || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'contact' }, payload));
    document.documentElement.dataset.lastContactEvent = method;
    if (typeof window.Shopify?.analytics?.publish === 'function') window.Shopify.analytics.publish('contact', payload);
  }

  function beforeNavigation(event) {
    captureArrival();
    decorate(linkFrom(event), readAttribution());
  }
  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(name => document.addEventListener(name, beforeNavigation, true));
  document.addEventListener('click', event => {
    const element = linkFrom(event);
    if (!element) return;
    const method = contactMethod(element);
    if (method) pushContact(element, method);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/contact"], form[id*="ContactForm"]')) {
      refresh();
      pushContact(event.target, 'form');
    }
  });
  ['page:loaded', 'shopify:section:load', 'visitorConsentCollected'].forEach(name => document.addEventListener(name, refresh));
  ['popstate', 'pageshow'].forEach(name => window.addEventListener(name, refresh));

  function initialize() {
    // Shopify's API applies the store's own region and consent settings.
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function' && !privacyLoading) {
      privacyLoading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => refresh());
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();


;(() => {
  if (window.ProHeadspaLeadTracker) return;
  const pendingStorage = 'proheadspa:pending-leads:v2';
  const pendingMaxAge = 30 * 60 * 1000;
  const pending = new Map(), observers = new Map();
  let timer, attempts = 0, knownOptOut = false;
  const root = document.documentElement;
  function status(key, state, eventId) {
    root.dataset.phMetaLeadState = state;
    for (const target of observers.get(key) || []) {
      target.dataset.phMetaLeadState = state;
      if (eventId) target.dataset.phMetaLeadEventId = eventId;
    }
  }
  function permission() {
    if (knownOptOut) return 'not_allowed';
    const privacy = window.Shopify?.customerPrivacy;
    try {
      const marketing = privacy?.marketingAllowed?.();
      const analytics = privacy?.analyticsProcessingAllowed?.();
      const sharing = privacy?.saleOfDataAllowed?.();
      root.dataset.phMetaMarketing = typeof marketing === 'boolean' ? String(marketing) : 'unavailable';
      root.dataset.phMetaAnalytics = typeof analytics === 'boolean' ? String(analytics) : 'unavailable';
      root.dataset.phMetaDataSharing = typeof sharing === 'boolean' ? String(sharing) : 'unavailable';
      if ([marketing, analytics, sharing].some(value => value === false)) return 'not_allowed';
      return marketing === true && analytics === true && sharing === true ? 'allowed' : 'pixel_managed';
    } catch (_) { return 'pixel_managed'; }
  }
  function validPending(entry) {
    return entry && /^(?:(?:distributor:)?[a-f0-9]{64}|ph-lead-[a-f0-9-]{36})$/.test(entry.key) &&
      /^ph-lead-[a-f0-9-]{36}$/.test(entry.eventId) && Number.isFinite(entry.createdAt) &&
      Date.now() >= entry.createdAt && Date.now() - entry.createdAt <= pendingMaxAge &&
      ['equipment', 'distributor'].includes(entry.type) && typeof entry.product === 'string' &&
      typeof entry.language === 'string';
  }
  function restorePending() {
    try {
      const records = JSON.parse(sessionStorage.getItem(pendingStorage) || '[]');
      if (Array.isArray(records)) for (const entry of records) if (validPending(entry) && !pending.has(entry.key)) pending.set(entry.key, entry);
    } catch (_) {}
  }
  function persistPending(allowed) {
    try {
      if (allowed && pending.size) sessionStorage.setItem(pendingStorage, JSON.stringify([...pending.values()]));
      else sessionStorage.removeItem(pendingStorage);
    } catch (_) {}
  }
  function schedule() {
    clearTimeout(timer);
    if (pending.size) timer = setTimeout(flush, ++attempts < 60 ? 1000 : 5000);
  }
  function flush() {
    clearTimeout(timer);
    const consent = permission();
    const pixelReady = typeof window.fbq === 'function' && typeof window.fbq.callMethod === 'function';
    const canPersist = consent === 'allowed' || (consent === 'pixel_managed' && pixelReady);
    if (canPersist) restorePending();
    for (const [key, entry] of pending) if (!validPending(entry)) { pending.delete(key); status(key, 'expired'); }
    if (consent === 'not_allowed') {
      persistPending(false);
      for (const key of pending.keys()) status(key, 'waiting_consent');
      schedule(); return;
    }
    if (!pixelReady) {
      if (canPersist) persistPending(true);
      for (const key of pending.keys()) status(key, 'waiting_pixel');
      schedule(); return;
    }
    persistPending(true);
    if (!pending.size) return;
    for (const [key, entry] of pending) {
      try {
        window.fbq('trackSingle', '1127369402941317', 'Lead', {
          content_name: entry.product,
          content_category: entry.type === 'distributor' ? 'b2b_distribution' : 'international_equipment',
          lead_type: entry.type, lead_stage: entry.stage || 'contact_saved', site: 'shopify', language: entry.language
        }, { eventID: entry.eventId });
        pending.delete(key);
        status(key, 'sent', entry.eventId);
      } catch (_) { status(key, 'pixel_error'); }
    }
    persistPending(true); schedule();
  }
  async function confirmed(details, context = {}) {
    const target = context.target || root;
    try {
      const identity = String(details.email || '').trim().toLowerCase() || String(details.phone || '').replace(/\D/g, '');
      if (!identity) return;
      const key = 'ph-lead-' + crypto.randomUUID();
      if (permission() === 'allowed' || (permission() === 'pixel_managed' && typeof window.fbq?.callMethod === 'function')) restorePending();
      if (!observers.has(key)) observers.set(key, new Set());
      observers.get(key).add(target);
      if (!pending.has(key)) pending.set(key, {
        key, eventId: key, createdAt: Date.now(),
        stage: context.stage === 'contact_submitted' ? 'contact_submitted' : 'contact_saved',
        product: context.distributor ? 'Distribution partnership' : String(details.product || '').slice(0,250),
        type: context.distributor ? 'distributor' : 'equipment', language: String(details.language || 'en').slice(0,10)
      });
      attempts = 0; flush();
    } catch (_) { target.dataset.phMetaLeadState = 'tracking_unavailable'; }
  }
  window.ProHeadspaLeadTracker = { confirmed, stepTwo: (details, context = {}) => confirmed(details, { ...context, stage: 'contact_submitted' }), version: '2026-10-31-step-two-no-contact-dedup' };
  document.addEventListener('visitorConsentCollected', event => {
    const detail = event.detail || {};
    const choices = [detail.marketingAllowed, detail.analyticsAllowed, detail.saleOfDataAllowed];
    if (choices.some(value => typeof value === 'boolean')) knownOptOut = choices.some(value => value === false);
    attempts = 0; flush();
  });
  document.addEventListener('consentTrackingApiLoaded', flush);
  window.addEventListener('pageshow', flush);
  window.addEventListener('online', flush);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) flush(); });
  document.dispatchEvent(new CustomEvent('proheadspa:lead-tracker-ready'));
  flush();
})();
